/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
const HAS_APP_NAVIGATION_KEY = /* @__PURE__ */ Symbol.for("NcContent:setHasAppNavigation");
const CONTENT_SELECTOR_KEY = /* @__PURE__ */ Symbol.for("NcContent:selector");
export {
  CONTENT_SELECTOR_KEY as C,
  HAS_APP_NAVIGATION_KEY as H
};
//# sourceMappingURL=constants-Ciwvl5xb.mjs.map
